import * as actionTypes from "../actionTypes";

export const setInfoFilters = (data) => {
  return {
    type: actionTypes.InspectionInfoFilters,
    payload: data,
  };
};

export const resetInfoFiltersLists = (data) => {
  return {
    type: actionTypes.ResetInspectionInfoFiltersLists,
    payload: data,
  };
};

export const resetInfoFilters = (data) => {
  return {
    type: actionTypes.ResetInspectionInfoFilters,
    payload: data,
  };
};

export const getInspectionLevelRequest = (data) => {
  return {
    type: actionTypes.InspectionLevelRequested,
    payload: data,
  };
};

export const getInspectionLevelSuccess = (data) => {
  return {
    type: actionTypes.InspectionLevelSuccess,
    payload: data,
  };
};

export const getInspectionDivisionsRequest = (data) => {
  return {
    type: actionTypes.InspectionDivisionRequested,
    payload: data,
  };
};
export const getInspectionDivisionsSuccess = (data) => {
  return {
    type: actionTypes.InspectionDivisionSuccess,
    payload: data,
  };
};

export const getInspectionClientsRequest = (data) => {
  return {
    type: actionTypes.InspectionClientRequested,
    payload: data,
  };
};

export const getInspectionClientsSuccess = (data) => {
  return {
    type: actionTypes.InspectionClientSuccess,
    payload: data,
  };
};

export const getInspectionServiceLocationsRequest = (data) => {
  return {
    type: actionTypes.InspectionServiceLocationRequested,
    payload: data,
  };
};

export const getInspectionServiceLocationsSuccess = (data) => {
  return {
    type: actionTypes.InspectionServiceLocationSuccess,
    payload: data,
  };
};

export const getInspectionSubLocationsRequest = (data) => {
  return {
    type: actionTypes.InspectionSubLocationRequested,
    payload: data,
  };
};

export const getInspectionSubLocationsSuccess = (data) => {
  return {
    type: actionTypes.InspectionSubLocationSuccess,
    payload: data,
  };
};

export const getInspectionSectionsRequest = (data) => {
  return {
    type: actionTypes.InspectionSectionRequested,
    payload: data,
  };
};

export const getInspectionSectionsSuccess = (data) => {
  return {
    type: actionTypes.InspectionSectionSuccess,
    payload: data,
  };
};

export const getInspectionInspectorsRequest = (data) => {
  return {
    type: actionTypes.InspectionInspectorRequested,
    payload: data,
  };
};

export const getInspectionInspectorsSuccess = (data) => {
  return {
    type: actionTypes.InspectionInspectorSuccess,
    payload: data,
  };
};

export const getInspectionRoomAreaRequest = (data) => {
  return {
    type: actionTypes.InspectionRoomAreaRequested,
    payload: data,
  };
};

export const getInspectionRoomAreaSuccess = (data) => {
  return {
    type: actionTypes.InspectionRoomAreaSuccess,
    payload: data,
  };
};

export const getInspectionServiceItemsRequest = (data) => {
  return {
    type: actionTypes.InspectionServiceItemsRequested,
    payload: data,
  };
};

export const getInspectionServiceItemsSuccess = (data) => {
  return {
    type: actionTypes.InspectionServiceItemsSuccess,
    payload: data,
  };
};

export const applyInfoFiltersRequest = (data) => {
  return {
    type: actionTypes.ApplyInspectionInfoFiltersRequested,
    payload: data,
  };
};

export const applyInfoFiltersRequestSuccess = (data) => {
  return {
    type: actionTypes.ApplyInspectionInfoFiltersSuccess,
    payload: data,
  };
};

export const getInspectionUserDetailRequest = (data) => {
  return {
    type: actionTypes.InspectionUserDetailRequested,
    payload: data,
  };
};

export const getInspectionUserDetailSuccess = (data) => {
  return {
    type: actionTypes.InspectionUserDetailSuccess,
    payload: data,
  };
};

export const generateInspectionPdfRequest = (data) => {
  return {
    type: actionTypes.GenerateInspectionPdfRequested,
    payload: data,
  };
};

export const generateInspectionPdfSuccess = (data) => {
  return {
    type: actionTypes.GenerateInspectionPdfSuccess,
    payload: data,
  };
};

export const getInspectionMasterDataRequest = (data) => {
  return {
    type: actionTypes.InspectionMasterDataRequested,
    payload: data,
  };
};

export const getInspectionMasterDataSuccess = (data) => {
  return {
    type: actionTypes.InspectionMasterDataSuccess,
    payload: data,
  };
};